import React from 'react'
import { useTranslation } from 'react-i18next'
import './index.css'

const QuoteSection : React.FC = () => {
	const { t } = useTranslation('home')

	return (
		<section className='quote-section-container'>
			<p className='quote-text'>
				{t('quote.text')}
			</p>
		</section>
	)
}

export default QuoteSection
